import { render, staticRenderFns } from "./form.vue?vue&type=template&id=b24f0f98"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=b24f0f98&prod&lang=stylus"
import style1 from "./form.vue?vue&type=style&index=1&id=b24f0f98&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports